(() => {
  class CustomerGallery extends HTMLElement {
    connectedCallback() {
      this.sliderElement = this.querySelector('.customer-gallery__slider');
      if (!this.sliderElement || this.swiper) return;

      this.swiper = new Swiper(this.sliderElement, {
        slidesPerView: Number.parseFloat(this.dataset.mobileItems || '2.5'),
        spaceBetween: 8,
        watchOverflow: true,
        navigation: {
          prevEl: this.querySelector('.customer-gallery__prev'),
          nextEl: this.querySelector('.customer-gallery__next'),
        },
        breakpoints: {
          990: {
            slidesPerView: Number.parseFloat(this.dataset.desktopItems || '4'),
            spaceBetween: 16,
          },
        },
      });

      this.onClick = this.handleClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    handleClick(event) {
      const opener = event.target.closest('[data-customer-gallery-open]');
      if (!opener || !this.contains(opener)) return;

      event.preventDefault();
      const modal = document.getElementById(opener.dataset.modalId);
      if (modal) modal.show(opener);
    }

    disconnectedCallback() {
      if (this.onClick) this.removeEventListener('click', this.onClick);
      this.swiper?.destroy(true, true);
      this.swiper = null;
    }
  }

  class CustomerGalleryModal extends ModalDialog {
    // Keep the modal within its Shopify section so section unload removes it.
    connectedCallback() {}

    ensureSwiper() {
      if (this.swiper) return;

      const slider = this.querySelector('.customer-gallery-modal__slider');
      if (!slider) return;

      const previousButton = this.querySelector('.customer-gallery-modal__prev');
      const nextButton = this.querySelector('.customer-gallery-modal__next');
      const hasMultipleSlides = slider.querySelectorAll('.swiper-slide').length > 1;

      if (previousButton) previousButton.hidden = !hasMultipleSlides;
      if (nextButton) nextButton.hidden = !hasMultipleSlides;

      this.swiper = new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 16,
        watchOverflow: true,
        keyboard: { enabled: true },
        navigation: {
          prevEl: previousButton,
          nextEl: nextButton,
        },
        on: {
          slideChange: () => this.pauseVideos(),
        },
      });
    }

    show(opener) {
      super.show(opener);
      this.ensureSwiper();

      const index = Number.parseInt(opener.dataset.mediaIndex, 10) || 0;
      this.pauseVideos();
      this.swiper?.keyboard?.enable();
      this.swiper?.slideTo(index, 0);

      if (opener.dataset.mediaType === 'video') {
        requestAnimationFrame(() => {
          const activeSlide = this.swiper?.slides[index];
          activeSlide?.querySelector('video')?.play().catch(() => {});
        });
      }
    }

    pauseVideos() {
      this.querySelectorAll('video').forEach((video) => video.pause());
    }

    hide() {
      this.pauseVideos();
      this.swiper?.keyboard?.disable();
      super.hide();
    }

    disconnectedCallback() {
      this.pauseVideos();
      this.swiper?.destroy(true, true);
      this.swiper = null;
    }
  }

  if (!customElements.get('customer-gallery')) {
    customElements.define('customer-gallery', CustomerGallery);
  }

  if (!customElements.get('customer-gallery-modal')) {
    customElements.define('customer-gallery-modal', CustomerGalleryModal);
  }
})();
